module.exports = __webpack_public_path__ + "img/dfa.f6243754.png";